import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import {
  Autocomplete,
  Button,
  Card,
  Checkbox,
  Grid,
  IconButton,
  Switch,
  TableFooter,
  TablePagination,
  TextField,
  Tooltip,
  Avatar,
  Box,
  Step,
  StepButton,
  Stepper,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { ClearIcon } from "@mui/x-date-pickers";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Footer from "examples/Footer";
import typography from "assets/theme/base/typography";
// icons
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import {
  Cancel,
  Check,
  Delete,
  Edit,
  PictureAsPdf,
  Visibility,
} from "@mui/icons-material";
import * as moment from "moment";
//Dialog Box
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Input } from "@mui/material";
import Typography from "@mui/material/Typography";
import ApiCalls from "services/flick_erp_api_call";
import { useSelector } from "react-redux";
import {
  candidatesList,
  candidateDetails,
  optionValues,
} from "./candidatesSlice";
import { employeeList } from "layouts/employees/employeesSlice";
import { useDispatch } from "react-redux";

import { getTimeFromDateTime } from "helpers/DateTime";
import { getDateFromDateTime } from "helpers/DateTime";
import MDAlert from "components/MDAlert";
import { stringify } from "stylis";
import FlickSwitch from "components/FlickSwitch";
import { setToastOpen } from "components/Toast/toastAlertSlice";
import { SearchBox } from "components/SearchBox";
import colors from "assets/theme/base/colors";
import { advertisementLists } from "../currentOpenings/jobAdvertisementSlice";
import verifiedIcon from "../../../assets/verified.png";
import { AddRecordsDialog, InterviewsDialog, CandidateInformationDialog } from "./candidateDialogs";
import { DocumentDialog, InterviewNameDialog, ScheduleInterviewDialog } from "./CandidateInterviewDialog";

function Candidates({ props, permissions, modulePermissions }) {

  const isMobile = useMediaQuery("(max-width:600px)");
  const { size } = typography;
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const surfaceColor = isDarkMode ? theme.palette.background.paper : colors.light.main;
  const mutedSurfaceColor = isDarkMode ? theme.palette.background.default : colors.background.accent;
  const borderColor = isDarkMode ? theme.palette.divider : "rgba(148, 163, 184, 0.24)";
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();

  const [interviewerNameError, setInterviewerNameError] = useState("");
  const [interviewTimeError, setInterviewTimeError] = useState("");
  const [interviewDateError, setInterviewDateError] = useState("");
  const [numberError, setNumberError] = useState("");

  useEffect(() => {
    getEmployee();
  }, []);

  // Get Employee List Api
  async function getEmployee() {
    var res = await ApiCalls.getEmployeesList("?status=active");
    if (res.success && res.code === 200) {
      // var data = JSON.parse(JSON.stringify(res.data));
      dispatch(employeeList({ employee: res.data }));
    } else {
    }
  }

  // Get Candidate Api
  const [candData, setCandData] = useState({});
  const handleOnNameClick = async (index, row) => {
    const can_id = row.id;

    const res = await ApiCalls.getCandidate(can_id, row);
    if (res.success && res.code == 200) {
      dispatch(candidateDetails(res.data));
      setCandData(res.data);
    } else {
    }
    setCandidateNameDialog(true);
  };
  const [searchBy, setSearchBy] = useState("Name");

  const detail = useSelector((state) => state.candidates.details);
  const selectedDocs = useSelector(
    (state) => state.candidates.details.documents_needed
  );
  var advertisements = useSelector((state) =>
    state.jobAdvertisement.jobAdvertisement
  );

  const [documentOpen, setDocumentOpen] = React.useState(false);
  const [documents, setDocuments] = useState([]);
  const [jobOfferCandidateContext, setJobOfferCandidateContext] = useState({
    candidateId: null,
    jobOpeningId: null,
  });
  const [jobOfferDetail, setJobOfferDetail] = useState({
    expected_doj: moment(new Date()).format("YYYY-MM-DD"),
    valid_till: moment(
      new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        new Date().getDate()
      )
    ).format("YYYY-MM-DD"),
  });

  const handleDocumentClose = () => {
    setDocumentOpen(false);
  };
  const getFinalInterviewContext = () => {
    const finalInterview = Array.isArray(detail?.interviews)
      ? [...detail.interviews].reverse().find((interview) => interview?.final_interview)
      : null;

    return {
      candidateId: detail?.id || null,
      jobOpeningId: finalInterview?.job_opening?.id || finalInterview?.job_opening || null,
    };
  };

  const handleDocumentOpen = async () => {
    const res = await ApiCalls.getDocuments();
    if (res.success && res.code == 200) {
      setDocuments(res.data);
    }
    setJobOfferCandidateContext(getFinalInterviewContext());
    setDocumentOpen(true);
  };

  // const [selectedValues, setSelectedValues] = useState(selectedDocs);
  const [selectedValues, setSelectedValues] = useState({});

  useEffect(() => {
    setSelectedValues(selectedDocs?.map((key) => key));
  }, [selectedDocs]);

  const handleDocumentChange = (key) => {
    if (selectedValues.includes(key)) {
      setSelectedValues((prevSelectedValues) =>
        prevSelectedValues.filter((value) => value !== key)
      );
    } else {
      setSelectedValues((prevSelectedValues) => [...prevSelectedValues, key]);
    }
  };

  // Get status and source api
  useEffect(() => {
    getOptionValue();
  }, []);

  // const [option, setOption] = useState({ source: {}, status: {} });
  async function getOptionValue() {
    const res = await ApiCalls.getCandiateStatusAndSource();
    if (res.success && res.code == 200) {
      // setOption(res.data);
      dispatch(optionValues({ candidates: res.data }));
    } else {
    }
  }

  const candidateOptionValues = useSelector(
    (state) => state.candidates.options.candidates
  );

  function convertSource(so) {
    const sourceValue = candidateOptionValues?.source[so] || "";
    return `${sourceValue}`;
  }
  function convertStatus(st) {
    const statusValue = candidateOptionValues?.status[st] || "";

    return `${statusValue}`;
  }

  const [scheduleInterviewRecord, setScheduleInterviewRecord] = useState({
    datetime: "",
    status: 0,
    rating: 0,
    feedback: "",
    evaluated_exp: 0,
    candidate: 0,
    interviewer: [],
    mode: "online",
    meeting_link: "",
    address: "",
    timezone: "Asia/Kolkata",
  });

  const [editableRowIndex, setEditableRowIndex] = useState(-1);
  const [editedData, setEditedData] = useState([]);
  const [editableInterviewRowIndex, setEditableInterviewRowIndex] =
    useState(-1);
  const [editedInterviewData, setEditedInterviewData] = useState({});
  const [currentCandidateIndex, setCurrentCandidateIndex] = useState(null);
  const [candidateNameDialog, setCandidateNameDialog] = React.useState(false);

  const [interviewDialog, setInterviewDialog] = React.useState(false);
  const [gmeetAuthenticated, setGmeetAuthenticated] = useState(true);

  const [gmeet, setGmeet] = useState(true);
  const [scheduleInterviewOpen, setScheduleInterviewOpen] =
    React.useState(false);
  const [meetingModeError, setMeetingModeError] = useState("");
  const handleSetGmeet = () => setGmeet(!gmeet);
  // gmeet
  useEffect(() => {
    getGmeetAuthenticateStatus();

    if (window.location.href.includes("code")) {
      const query = new URLSearchParams(window.location.search);
      const code = query.get("code");
      postGoogleResponseCode(code);
    }
  }, []);
  const getGmeetAuthenticateStatus = async () => {
    var res = await ApiCalls.getStatusOfGoogleAuthenticate();
    setGmeetAuthenticated(res.success ? true : false);
  };
  const handleOnInterviewOpen = (index) => {
    setCurrentCandidateIndex(index);
    setInterviewDialog(true);
  };
  const handleInterviewClose = () => {
    setCurrentCandidateIndex(null);
    setInterviewDialog(false);
  };

  const handleOnScheduleInterview = (row) => {
    setScheduleInterviewRecord((state) => ({
      ...state,
      candidate: row.id || "",
      evaluated_exp: row.experience || "",
      status: row.status || "",
      datetime: "",
      interviewer: [],
      mode: "online",
      meeting_link: "",
      address: "",
      timezone: "Asia/Kolkata",
    }));

    setScheduleInterviewOpen(true);
  };
  const handleScheduleInterviewClose = () => {
    setScheduleInterviewOpen(false);
    setMeetingModeError("");
  };

  const [interviewDate, setInterviewDate] = useState({
    interviewDate: "",
  });
  const [description, setDescription] = useState("");
  const [finalInterview, setFinalInterview] = useState(false);
  const [interviewTime, setInterviewTime] = useState({
    interviewTime: "",
  });
  const handleInputDateTimeInterviewChange = (selectedDateTime) => {
    if (!selectedDateTime) {
      return "";
    }

    const dateObject = new Date(selectedDateTime);
    return dateObject.toISOString();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRecord((prevState) => ({ ...prevState, [name]: value }));

    if (name === "full_name") {
      setFullNameError("");
    } else if (name === "email") {
      setEmailError("");
    } else if (name === "experience") {
      setExperienceError("");
    }
  };

  const [recordsOpen, setRecordsOpen] = React.useState(false);
  const handleRecordsOpen = () => {
    setEditableRowIndex(-1);
    setRecordsOpen(true);
  };
  const handleRecordsClose = () => {
    setRecordsOpen(false);
  };

  const [rows, setRows] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Api for get Job Advertisement List
  async function jobAdvertisement() {
    const res = await ApiCalls.getAdvertisementList();
    if (res.success && res.code === 200) {
      dispatch(advertisementLists({ jobAdvertisement: res.data }));
    } else {
    }
  }

  // get candidates List api
  useEffect(() => {
    jobAdvertisement()
    getListCandidates();
  }, []);

  async function getListCandidates(queryParams) {
    const res = await ApiCalls.getCandidatesList(queryParams);
    if (res.success && res.code == 200) {
      setData(res.data);
      dispatch(candidatesList({ candidates: res.data }));
    } else {
    }
  }

  const candidate = useSelector((state) => state.candidates.candidates);

  //create candidates api
  const [showAlert, setShowAlert] = useState(null);
  const [newRecord, setNewRecord] = useState({
    full_name: "",
    mobile: "",
    email: "",
    experience: "",
    status: "",
    source: "",
    jd: "",
    recruiter: [],
    cv: "",
  });
  // schedule interview api
  const handleScheduleInterview = async () => {
    let hasError = false;
    let error = "This field may not be blank.";
    const interviewerId = scheduleInterviewRecord?.interviewer?.map((interviewer) => interviewer?.id);

    var payload = {
      interviewer: interviewerId,
      candidate: scheduleInterviewRecord.candidate,
      datetime: handleInputDateTimeInterviewChange(
        scheduleInterviewRecord.datetime
      ),
      meeting_note: description,
      final_interview: finalInterview,
      mode: scheduleInterviewRecord.mode,
      timezone: scheduleInterviewRecord.timezone || "Asia/Kolkata",
    };

    if (scheduleInterviewRecord.mode === "online") {
      payload.meeting_link = scheduleInterviewRecord.meeting_link;
    } else {
      payload.address = scheduleInterviewRecord.address;
    }

    if (
      !scheduleInterviewRecord.datetime
    ) {
      setInterviewDateError(error);
      setInterviewTimeError(error);
      hasError = true;
    } else {
      setInterviewDateError("");
      setInterviewTimeError("");
    }
    if (scheduleInterviewRecord.interviewer.length === 0) {
      setInterviewerNameError(error);
      hasError = true;
    } else {
      setInterviewerNameError("");
    }
    if (
      (scheduleInterviewRecord.mode === "online" && !scheduleInterviewRecord.meeting_link?.trim()) ||
      (scheduleInterviewRecord.mode === "offline" && !scheduleInterviewRecord.address?.trim())
    ) {
      setMeetingModeError(
        scheduleInterviewRecord.mode === "online"
          ? "Meeting link is required for online interviews."
          : "Address is required for offline interviews."
      );
      hasError = true;
    } else {
      setMeetingModeError("");
    }

    if (!hasError) {
      // if(payload.candidate && payload.datetime && payload.interviewer){
      const res = await ApiCalls.postInterview(payload, true);
      if (res.success && res.code == 201) {
        handleScheduleInterviewClose();
        getListCandidates();
      } else if (res.success == false && res.code == 400) {
      } else {
      }
      // getListCandidates();
    }
  };
  const alertContent = (name) => (
    <MDTypography variant="body2" color="white">
      {name}
    </MDTypography>
  );

  const [fullNameError, setFullNameError] = useState("");
  const [experienceError, setExperienceError] = useState("");
  const [jdError, setJDError] = useState("");
  const [cvError, setCVError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [sourceError, setSourceError] = useState("");
  const [statusError, setStatusError] = useState("");

  const handleAddRecord = async (file) => {
    let hasError = false;
    let error = "This field may not be blank.";

    if (newRecord.full_name === undefined || newRecord.full_name === "") {
      setFullNameError(error);
      hasError = true;
    } else {
      setFullNameError("");
    }
    if (newRecord.mobile === undefined || newRecord.mobile === "") {
      setNumberError(error);
      hasError = true;
    } else {
      setNumberError("");
    }
    if (newRecord.experience === undefined || newRecord.experience === "") {
      setExperienceError(error);
      hasError = true;
    } else {
      setExperienceError("");
    }
    if (newRecord.email === undefined || newRecord.email === "") {
      setEmailError(error);
      hasError = true;
    } else {
      setEmailError("");
    }
    if (resume === null) {
      setCVError("please select file");
      hasError = true;
    } else {
      setCVError("");
    }
    if (newRecord.source === undefined || newRecord.source === "") {
      setSourceError(error);
      hasError = true;
    } else {
      setSourceError("");
    }
    // if (newRecord.jd === undefined || newRecord.jd === "") {
    //   setJDError(error);
    //   hasError = true;
    // } else {
    //   setJDError("");
    // }
    if (newRecord.status === undefined || newRecord.status === "") {
      setStatusError(error);
      hasError = true;
    } else {
      setStatusError("");
    }

    if (
      newRecord.id &&
      newRecord.full_name &&
      newRecord.mobile &&
      newRecord.experience &&
      newRecord.email &&
      newRecord.status &&
      newRecord.source &&
      newRecord.recruiter &&
      newRecord.cv &&
      newRecord.jd
    ) {
      const newDataRow = createData(
        newRecord.id,
        newRecord.full_name,
        newRecord.mobile,
        newRecord.experience,
        newRecord.email,
        newRecord.status,
        newRecord.source,
        newRecord.recruiter,
        newRecord.cv,
        newRecord.jd
      );

      setRows([...rows, newDataRow]);

      setNewRecord({
        id: "",
        full_name: "",
        mobile: "",
        email: "",
        experience: "",
        status: "",
        source: "",
        cv: "",
        jd: ''
      });
    }
    const formData = new FormData();
    formData.append("cv", resume);
    formData.append("full_name", newRecord.full_name);
    formData.append("mobile", newRecord.mobile);
    formData.append("email", newRecord.email);
    formData.append("experience", newRecord.experience);
    formData.append("source", newRecord.source);
    formData.append("status", newRecord.status);
    formData.append("job_ad", '');

    formData.append("recruiter", newRecord.recruiter);
    // formData.append("modified_at", 'check')

    if (!hasError) {
      const res = await ApiCalls.postCandidate(formData, true, true);
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? // It's the last step, but not all steps have been completed, find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
          : activeStep + 1;
      setActiveStep(newActiveStep);
      if (res.success && res.code == 201) {
        getListCandidates();
        setCandidateData(res.data)
        // handleRecordsClose();
        setNewRecord({});
      } else {
        if (res.code === 400) {
          setShowAlert("Please enter the data");
          const errors = res.data;
          if (errors.full_name) {
            alert(errors.full_name);
          } else if (errors.experience) {
            alert(errors.experience);
          } else if (errors.email) {
            alert(errors.email);
          } else if (errors.job_ad) {
            alert(errors.job_ad);
          } else if (errors.cv) {
            alert(errors.cv);
          } else if (errors.source) {
            alert(errors.source);
          }
          else if (errors.jd) {
            alert(errors.jd);
          } else if (errors.status) {
            alert(errors.status);
          }
        }
      }
    }
  };
  const handleEditInterviewRecord = (row, actualIndex) => {
    setEditableInterviewRowIndex(actualIndex);
    setEditedInterviewData(row);
    // var records = employeesList.filter((v) =>
    //   editedInterviewData?.interviewer?.some((a) => v.id == a)
    // );
  };

  // delete interview record
  const handleDeleteInterviewRecord = async (row) => {
    const res = await ApiCalls.deleteInterview(row.id);
    if (res.success && res.code === 204) {
      getListCandidates();
    } else {
    }
  };

  //update interview record
  const handleInterviewSaveClick = async () => {
    var data = {
      datetime: editedInterviewData.datetime,
      status: editedInterviewData.status,
      rating: editedInterviewData.ratings,
      evaluated_exp: editedInterviewData.evaluated_exp,
      feedback: editedInterviewData.feedback,
      candidate: editedInterviewData.candidate,
      interviewer: editedInterviewData.interviewer,
    };
    const res = await ApiCalls.patchInterview(
      data,
      editedInterviewData.id,
      false
    );
    if (res.success && res.code == 200) {
    } else {
    }
    getListCandidates();
    setEditedInterviewData({});
    setEditableInterviewRowIndex(-1);
  };

  // delete candidate api
  const handleDeleteClick = async (row) => {
    const res = await ApiCalls.deleteCandidate(row.id);

    if (res.success && res.code === 204) {
      getListCandidates();
    } else {
    }
  };

  // update candidate api
  const handleEditClick = (row, actualIndex) => {
    setEditableRowIndex(actualIndex);
    setEditedData([...data]);
    setID(row.id);
  };

  const handleFieldChange = (event, fieldName) => {
    const updatedData = [...editedData];
    const editedRecord = { ...updatedData[editableRowIndex] };

    editedRecord[fieldName] = event.target.value;
    updatedData[editableRowIndex] = editedRecord;
    setEditedData(updatedData);
  };

  const [id_, setID] = useState();

  const handleSaveClick = async () => {
    const editedRow = editedData?.find((row) => row.id === id_);
    const formData = new FormData();
    if (resume) {
      formData.append("cv", resume);
    }
    if (selectedValues) {
      const docs = selectedValues?.map((key) => parseInt(key, 10));

      docs.forEach((doc) => {
        formData.append("documents_needed", doc);
      });
    }
    if (editedRow !== undefined) {
      formData.append("full_name", editedRow.full_name);
      formData.append("mobile", editedRow.mobile);
      formData.append("email", editedRow.email);
      formData.append("experience", editedRow.experience);
      formData.append("status", editedRow.status);
      formData.append("source", editedRow.source);

      editedRow?.job_ad != null && editedRow?.job_ad != undefined ? formData.append("job_ad", editedRow?.job_ad) : null;

      formData.append("recruiter", parseInt(editedRow.recruiter));
    }

    const res = await ApiCalls.updateCandidate(id_, formData, true);
    if (res.success && res.code == 200) {
      setCandidateNameDialog(false);

      setData(editedData);
      getListCandidates();
      setEditableRowIndex(null);
    } else {
      setCandidateNameDialog(false);
    }
  };

  const handleInterivewCancelClick = () => {
    setEditableInterviewRowIndex(-1);
  };

  const handleCancelClick = () => {
    setEditableRowIndex(-1);
  };

  const [resume, setResume] = useState(null);
  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    let extension = file.name.split(".").pop();
    if (extension == "pdf" || extension == "docx") {
      setResume(file);
      setCVError("");
    } else {
      alert("Only PDF or DOCX Are Allowed ");
    }
  };
  // Pagination
  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - candidate.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [data, setData] = useState([]);
  const [selectedInterview, setSelectedInterview] = useState(null);
  const [interviewDetailsDialog, setInterviewDetailsDialog] = useState(false);
  const handleOnInterviewerNameClick = (interview) => {
    setSelectedInterview(interview);
    setInterviewDetailsDialog(true);
  };
  const handleInterviewerNameClose = (interview) => {
    setInterviewDetailsDialog(false);
  };

  const employeesList = useSelector((state) => state.employee.employee);
  const employeeOptions = employeesList.map((employee) => ({
    value: `${employee.id}`,
    label: `${employee.user.firstname} ${employee.user.lastname}`,
  }));

  const getEmployeeNameById = (interviewerList) => {
    if (!interviewerList) {
      return "";
    }

    if (Array.isArray(interviewerList)) {
      var record = employeesList.filter((v) =>
        interviewerList.some((i) => i === v.id)
      );
      if (record.length > 0) {
        return record.reduce(
          (accumulator, name) =>
            accumulator + name.user.firstname + " " + name.user.lastname + " ",
          ""
        );
      }
    } else {
      var employee = employeesList.find((v) => v.id === interviewerList);
      if (employee) {
        return employee.user.firstname + " " + employee.user.lastname;
      }
    }

    return "";
  };
  const handleEmpSearch = (query) => {
    if (searchBy == "Name") {
      getListCandidates(`?full_name_starts_with=${query}`);
    } else if (searchBy == "Phone") {
      getListCandidates(`?mobile__icontains=${query}`);
    } else if (searchBy == "Email") {
      getListCandidates(`?email__icontains=${query}`);
    } else if (searchBy == "Status") {
      getListCandidates(`?status=${query}`);
    }
  };
  async function makeJobOffer(candidateId) {
    const resolvedCandidateId = candidateId || jobOfferCandidateContext?.candidateId;
    const resolvedJobOpeningId = jobOfferCandidateContext?.jobOpeningId;

    if (!resolvedCandidateId || !resolvedJobOpeningId) {
      dispatch(
        setToastOpen({
          isOpen: true,
          message: "A final interview with a valid job opening is required before creating a job offer.",
        })
      );
      setDocumentOpen(false);
      return;
    }

    let data = {
      expected_doj: jobOfferDetail.expected_doj,
      ctc: jobOfferDetail.ctc,
      active: true,
      candidate: resolvedCandidateId,
      job_opening: resolvedJobOpeningId,
    };
    var res = await ApiCalls.postJobOffer(data, false);
    if (res.success && res.code == 201) {
      setDocumentOpen(false);
    } else {
      setDocumentOpen(false);
    }
  }

  var advertisementss = useSelector((state) =>
    state.jobAdvertisement.jobAdvertisement
  );
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ['Candidate Information', 'JOB Openings'];
  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };
  const handleNext = () => {
    // if (!validateCurrentStep()) {
    //     return; // Stop if validation fails
    // }
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed, find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const totalSteps = () => {
    return steps.length;
  };
  const [completed, setCompleted] = React.useState({});
  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const [candidateData, setCandidateData] = useState(null)
  const handleJobOpenings = async () => {
    try {
      const jobIds = newRecord.jd.map((job) => job.id);
      const payload = {
        job_openings: jobIds
      }
      if (candidateData.id) {
        const candidateId = candidateData.id;
        const res = await ApiCalls.postJobOpenings(payload, candidateId, true, true);
        handleRecordsClose();
      } else {
        console.error("Failed to get candidate ID:");
      }
    } catch (error) {
      console.error("Error in handleJobOpenings:", error);
    }
  };
  const isSmallScreenSearch = useMediaQuery("(max-width:600px)");
  return (
    <>
      {/* <DashboardLayout>
      <DashboardNavbar /> */}
      <MDBox>
        <Card
          sx={{
            borderRadius: "30px",
            boxShadow: "none",
            border: `1px solid ${borderColor}`,
            background: isDarkMode
              ? "linear-gradient(160deg, rgba(30,41,59,0.96), rgba(15,23,42,0.9))"
              : "linear-gradient(145deg, rgba(255,255,255,0.98), rgba(245,247,255,0.98))",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", m: 1, p: { xs: 1, md: 1.5 }, gap: 2 }}>
            <Box>
            <MDTypography variant="h4" sx={{ fontWeight: 700, letterSpacing: "-0.04em", p: 1 }}>
              Candidates
            </MDTypography>
            <MDTypography variant="body2" color="text" sx={{ px: 1, pt: 0.2, maxWidth: 720, lineHeight: 1.7 }}>
              Review applicants, filter their pipeline readiness, and jump into interviews or details from a cleaner candidate workspace.
            </MDTypography>
            </Box>
            <MDBox
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              justifyContent="space-between"
              alignItems="center"
              py={1.5}
              px={1.5}
            >
              <MDBox
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                // justifyContent="space-between"
                gap={1}
                alignItems="center"
                flexWrap="wrap"
                color="text"
                fontSize={size.sm}
                px={1.5}
              // width="100%"
              >
                <MDBox
                  pr={1}
                  mr={1}
                  display="flex"
                  alignItems="center"
                  flexDirection={isMobile ? "column" : "row"}
                  justifyContent={isMobile ? "center" : "space-between"}
                  sx={{
                    borderRadius: "22px",
                    p: 0.75,
                    backgroundColor: mutedSurfaceColor,
                    border: `1px solid ${borderColor}`,
                  }}
                >
                  <SearchBox
                    width={isMobile ? "100%" : 350}
                    placeholder={"Search Candidate"}
                    onChange={(e) => {
                      if (e.length >= 3) {
                        handleEmpSearch(e);
                      }
                    }}
                    sort={
                      <Autocomplete
                        options={["Name", "Phone", "Email"]}
                        value={searchBy}
                        onChange={(event, newValue) => {
                          setSearchBy(newValue);
                        }}
                        sx={{
                          width: isMobile ? "100%" : "155px",
                          paddingLeft: isMobile ? "0" : "5px",
                          paddingRight: isMobile ? "0" : "5px",
                          "& .MuiInputBase-root": {
                            borderRadius: "14px",
                            backgroundColor: surfaceColor,
                            px: 1,
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                            }}
                          />
                        )}
                      />
                    }
                  />
                  <Autocomplete
                    options={
                      candidateOptionValues?.status
                        ? Object.entries(candidateOptionValues?.status).map(
                          ([key, value]) => ({ value: key, label: value })
                        )
                        : []
                    }
                    onChange={(event, newValue) => {
                      if (newValue != undefined) {
                        getListCandidates(`?status=${newValue.value}`);
                      } else {
                        getListCandidates();
                      }
                    }}
                    sx={{
                      width: "110px",
                      paddingBottom: "2px",
                      "& .MuiInputBase-root": {
                        borderRadius: "14px",
                        backgroundColor: surfaceColor,
                        px: 1,
                      },
                      "& .MuiAutocomplete-popupIndicator": {
                        backgroundColor: isDarkMode ? "transparent" : "#fff",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                        }}
                        sx={{
                          input: { color: isDarkMode ? colors.light.main : colors.dark.main },
                          "& .MuiSvgIcon-root": {
                            color: isDarkMode ? colors.light.main : "#000",
                          },
                        }}
                        placeholder="Sort By"
                        variant="standard"
                      />
                    )}
                  />
                </MDBox>
                {permissions?.includes(modulePermissions?.create_permission) && (
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleRecordsOpen}
                    sx={{ borderRadius: "16px", px: 2.5, minHeight: 44 }}
                  >
                    Add Records
                  </MDButton>
                )}
                {/* )} */}
              </MDBox>
            </MDBox>
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              m: 2,
              mt: 0,
              borderRadius: "24px",
              backgroundColor: surfaceColor,
              border: `1px solid ${borderColor}`,
              boxShadow: "none",
              overflow: "hidden",
            }}
          >
            <Table aria-label="simple table">
              <TableBody data-testid="tBody">
                <TableRow sx={{ backgroundColor: mutedSurfaceColor }}>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Name
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Number
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Email
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Experience
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Recruiter
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Job ID
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Source
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Status
                  </TableCell>
                  <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                    Resume
                  </TableCell>
                  {(permissions?.includes(
                    modulePermissions?.interview_list_permission
                  ) ||
                    permissions?.includes(
                      modulePermissions?.interview_create_permission
                    )) && (
                      <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                        Interview
                      </TableCell>
                    )}
                  {permissions?.includes(
                    modulePermissions?.delete_permission
                  ) && (
                      <TableCell variant="head" sx={{ color: isDarkMode ? colors.light.main : "black", fontWeight: 700 }}>
                        Actions
                      </TableCell>
                    )}
                </TableRow>
              </TableBody>

              <TableBody>
                {(rowsPerPage > 0
                  ? candidate.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  : candidate
                )?.map((row, index) => {
                  const actualIndex = index + page * rowsPerPage;
                  return (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:hover": {
                          backgroundColor: isDarkMode ? "rgba(255,255,255,0.03)" : "rgba(103,80,164,0.04)",
                        },
                      }}
                    >
                      <TableCell
                        sx={{ whiteSpace: "nowrap", cursor: "pointer", fontSize: '14px' }}
                        style={{ fontWeight: "bold" }}
                        onClick={() => {
                          handleEditClick(row, actualIndex);
                          handleOnNameClick(actualIndex, row);
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1.25}>
                          <Avatar sx={{ width: 36, height: 36, bgcolor: colors.info.main, fontSize: "0.9rem" }}>
                            {row.full_name?.charAt(0)?.toUpperCase() || "C"}
                          </Avatar>
                          <Box>
                            <Typography fontWeight={700} fontSize="0.92rem">
                              {row.full_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Candidate Profile
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>{row.mobile}</TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>{row.email}</TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        <Box
                          sx={{
                            px: 1.25,
                            py: 0.6,
                            borderRadius: "999px",
                            display: "inline-flex",
                            backgroundColor: isDarkMode ? "rgba(255,255,255,0.05)" : "rgba(103,80,164,0.06)",
                          }}
                        >
                          {row.experience} years
                        </Box>
                      </TableCell>
                      <TableCell style={{ whiteSpace: "nowrap", fontSize: '14px', fontWeight: 'normal' }}>
                        {getEmployeeNameById(row.recruiter)}
                      </TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        1
                      </TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>{convertSource(row.source)}</TableCell>
                      <TableCell style={{ fontSize: '14px', fontWeight: 'normal' }}>
                        <Box
                          sx={{
                            px: 1.25,
                            py: 0.6,
                            borderRadius: "999px",
                            display: "inline-flex",
                            backgroundColor: isDarkMode ? "rgba(34,197,94,0.12)" : "rgba(34,197,94,0.08)",
                            color: isDarkMode ? colors.light.main : colors.success.main,
                            fontWeight: 600,
                          }}
                        >
                          {convertStatus(row.status)}
                        </Box>
                      </TableCell>

                      {row?.cv ? (
                        <TableCell style={{ whiteSpace: "nowrap" }}>
                          <Tooltip title="Open">
                            <a
                              aria-label="open"
                              href={row.cv}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <h5 style={{ color: isDarkMode ? colors.light.main : "black" }}>
                                <Icon
                                  sx={{
                                    marginRight: "3px",
                                    marginBottom: "-2px",
                                  }}
                                >
                                  <PictureAsPdf />
                                </Icon>
                                Resume
                              </h5>
                            </a>
                          </Tooltip>
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography variant="body2" color="text.secondary">Not found</Typography>
                        </TableCell>
                      )}
                      {(permissions?.includes(
                        modulePermissions?.interview_list_permission
                      ) ||
                        permissions?.includes(
                          modulePermissions?.interview_create_permission
                        )) && (
                          <TableCell sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {permissions?.includes(
                              modulePermissions?.interview_list_permission
                            ) && (
                                <Tooltip title="View">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      handleOnInterviewOpen(actualIndex);
                                    }}
                                  >
                                    <Visibility />
                                  </IconButton>
                                </Tooltip>
                              )}
                            {/* {permissions?.includes(
                              modulePermissions?.interview_create_permission
                            ) && (
                                <Tooltip title="Schedule">
                                  <IconButton
                                    size="small"
                                    onClick={() => {

                                      if (user.employee_id == row.recruiter) {
                                        handleOnScheduleInterview(row);
                                      } else {
                                        alert("Recruiter and Looged-In user should be same to schedule the interview")
                                      }

                                    }}
                                  >
                                    <CalendarTodayIcon />
                                  </IconButton>
                                </Tooltip>
                              )} */}
                          </TableCell>
                        )}
                      {permissions?.includes(
                        modulePermissions?.delete_permission
                      ) && (
                          <TableCell>
                            {permissions?.includes(
                              modulePermissions?.delete_permission
                            ) && (
                                <Tooltip title="Delete">
                                  <IconButton
                                    size="small"
                                    onClick={() => {
                                      handleDeleteClick(row);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                              )}
                          </TableCell>
                        )}
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableFooter>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={12}
                  count={candidate.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      "aria-label": "rows per page",
                    },
                    actions: {
                      showFirstButton: true,
                      showLastButton: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableFooter>
            </Table>
          </TableContainer>
        </Card>
      </MDBox>
      <br />

      {/* Dialog Box for details */}
      <CandidateInformationDialog
        candidateNameDialog={candidateNameDialog}
        editedData={editedData}
        editableRowIndex={editableRowIndex}
        candidateOptionValues={candidateOptionValues}
        convertStatus={convertStatus}
        convertSource={convertSource}
        employeeOptions={employeeOptions}
        advertisements={advertisements}
        handleFileSelect={handleFileSelect}
        detail={detail}
        permissions={permissions}
        modulePermissions={modulePermissions}
        jdError={jdError}
        handleFieldChange={handleFieldChange}
        setJDError={setJDError}
        handleCancelClick={handleCancelClick}
        setCandidateNameDialog={setCandidateNameDialog}
        handleSaveClick={handleSaveClick}
        handleDocumentOpen={handleDocumentOpen}
      />

      {/* Dialog for interview */}
      <InterviewsDialog
        interviewDialog={interviewDialog}
        permissions={permissions}
        modulePermissions={modulePermissions}
        candidate={candidate}
        currentCandidateIndex={currentCandidateIndex}
        handleInterviewClose={handleInterviewClose}
        handleInterivewCancelClick={handleInterivewCancelClick}
        handleOnInterviewerNameClick={handleOnInterviewerNameClick}
        handleDeleteInterviewRecord={handleDeleteInterviewRecord}
        getEmployeeNameById={getEmployeeNameById}
        getTimeFromDateTime={getTimeFromDateTime}
        getDateFromDateTime={getDateFromDateTime}
      />

      {/* Dialog box for interview name click */}
      {/* need to check where is it ? */}
      <InterviewNameDialog
        interviewDetailsDialog={interviewDetailsDialog}
        selectedInterview={selectedInterview}
        setInterviewDetailsDialog={setInterviewDetailsDialog}
        getEmployeeNameById={getEmployeeNameById}
        getTimeFromDateTime={getTimeFromDateTime}
        getDateFromDateTime={getDateFromDateTime}
        handleInterviewerNameClose={handleInterviewerNameClose}
      />

      {/* Dialog Box for Schedule Interview */}
      {/* need to check that how can I pass job opnings ID */}
      <ScheduleInterviewDialog
        scheduleInterviewOpen={scheduleInterviewOpen}
        handleScheduleInterviewClose={handleScheduleInterviewClose}
        showAlert={showAlert}
        employeesList={employeesList}
        interviewTimeError={interviewTimeError}
        interviewTime={interviewTime}
        interviewDateError={interviewDateError}
        interviewDate={interviewDate}
        description={description}
        finalInterview={finalInterview}
        interviewerNameError={interviewerNameError}
        setScheduleInterviewRecord={setScheduleInterviewRecord}
        setInterviewerNameError={setInterviewerNameError}
        setInterviewTime={setInterviewTime}
        setInterviewTimeError={setInterviewTimeError}
        setInterviewDate={setInterviewDate}
        setInterviewDateError={setInterviewDateError}
        setDescription={setDescription}
        setFinalInterview={setFinalInterview}
        gmeetAuthenticated={gmeetAuthenticated}
        handleScheduleInterview={handleScheduleInterview}
        setShowAlert={setShowAlert}
        scheduleInterviewRecord={scheduleInterviewRecord}
        meetingModeError={meetingModeError}
        setMeetingModeError={setMeetingModeError}
      />

      {/* Dialog Box for Document */}
      {/* need to check where is it ? */}
      <DocumentDialog
        documentOpen={documentOpen}
        handleDocumentClose={handleDocumentClose}
        documents={documents}
        handleDocumentChange={handleDocumentChange}
        jobOfferDetail={jobOfferDetail}
        setJobOfferDetail={setJobOfferDetail}
        selectedValues={selectedValues}
        handleSaveClick={handleSaveClick}
        makeJobOffer={makeJobOffer}
      />

      {/* Dialog Box for Add Records */}
      <AddRecordsDialog
        recordsOpen={recordsOpen}
        handleRecordsClose={handleRecordsClose}
        activeStep={activeStep}
        isSmallScreen={isSmallScreen}
        steps={steps}
        completed={completed}
        handleStep={handleStep}
        allStepsCompleted={allStepsCompleted}
        showAlert={showAlert}
        newRecord={newRecord}
        handleInputChange={handleInputChange}
        fullNameError={fullNameError}
        numberError={numberError}
        emailError={emailError}
        experienceError={experienceError}
        candidateOptionValues={candidateOptionValues}
        convertSource={convertSource}
        employeesList={employeesList}
        editedData={editedData}
        editableRowIndex={editableRowIndex}
        convertStatus={convertStatus}
        cvError={cvError}
        handleFileSelect={handleFileSelect}
        totalSteps={totalSteps}
        handleBack={handleBack}
        handleAddRecord={handleAddRecord}
        sourceError={sourceError}
        statusError={statusError}
        setNewRecord={setNewRecord}
        setSourceError={setSourceError}
        setStatusError={setStatusError}
        advertisementss={advertisementss}
        handleJobOpenings={handleJobOpenings}
        jdError={jdError}
      />

      {/* </DashboardLayout> */}
    </>
  );
}
export default Candidates;
